/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Button, ButtonToolbar, ButtonGroup, Col, Row } from 'reactstrap'

import { css } from '@emotion/react';
import { RingLoader } from 'react-spinners'

import UserAdminModal from './UserAdminModal'

import ReactTable from 'react-table-legacy'
import "react-table-legacy/react-table.css";

import prettyBytes from 'pretty-bytes'

import {AppContext} from '../../AppContext';

class UserList extends React.Component
{
  columnKey = 'userAdministrationTab.userList.columnWidths';
  debouncedSaveColumnWidths = null;
  sortColumnLS = 'userAdministrationTab.userList.sortColumn';
  disableSelectionHandler = false;
  columnWidths = {};
  currentViewIndex = undefined;

  clearSelectedRows()
  {
    this.currentViewIndex = undefined;
    this.setState({selectedRows: []});
  }

  closeUserAdminModal(event, refresh)
  {
    this.setState({userAdminModalIsOpen: false});
    if (refresh) this.fetchUserList();
  }

  componentDidMount()
  {
    this.columnWidths = this.context.appLocalStorage.getColumnWidths(this.state.columns, this.columnKey);
    let sortColumn = JSON.parse(this.context.appLocalStorage.getItem(this.sortColumnLS))
    if (null === sortColumn) sortColumn = undefined;
    this.setState({sortColumn: sortColumn});
    this.fetchUserList();
  }

  constructor(props)
  {
    super();

    const columns = 
    [
      {Header: 'Username', id: 'username', accessor: 'username', 
        Cell: row => <div><span title={row.value}>{row.value}</span></div>},
      {Header: 'Email', id: 'emailAddress', accessor: 'emailAddress', 
        Cell: row => <div><span title={row.value}>{row.value}</span></div>},
      {Header: 'First Name', id: 'firstName', accessor: 'firstName', 
        Cell: row => <div><span title={row.value}>{row.value}</span></div>},
      {Header: 'Middle Name', id: 'middleName', accessor: 'middleName', show: false,
        Cell: row => <div><span title={row.value}>{row.value}</span></div>},
      {Header: 'Last Name', id: 'lastName', accessor: 'lastName', 
        Cell: row => <div><span title={row.value}>{row.value}</span></div>},
      {Header: 'Status', id: 'accountStatus', accessor: 'accountStatus', 
        Cell: row => <div><span title={row.value}>{row.value}</span></div>},
      {Header: 'Type', id: 'accountType', accessor: 'accountType', 
        Cell: row => <div><span title={row.value}>{row.value}</span></div>},
      {Header: 'Created', id: 'creationDate', accessor: d => {return d.creationDate},
        Cell: rowInfo => (<div><span title={window.formatTimestamp(rowInfo.row.creationDate, true)}>{window.formatTimestamp(rowInfo.row.creationDate, false)}</span></div>)},
      {Header: 'Active Sessions', id: 'activeSessions', accessor: 'activeSessionCount'},
      {Header: 'Last Activity', id: 'lastActivity', accessor: d => {return d.lastActivity},
        Cell: rowInfo => (<div><span title={window.formatTimestamp(rowInfo.row.lastActivity, true)}>{window.formatTimestamp(rowInfo.row.lastActivity, false)}</span></div>)},
      {Header: '# of Items', id: 'numberOfItems', accessor: 'usageByUser.itemCount', 
        Cell: row => (<div>{new Intl.NumberFormat().format(parseInt(row.value, 10))}</div>)},
      {Header: 'Bytes Used', id: 'bytesUsed', accessor: 'usageByUser.totalUsage',
        Cell: row => (<div><span title={new Intl.NumberFormat().format(parseInt(row.value, 10)) + ' Bytes'}>{prettyBytes(parseInt(row.value, 10))}</span></div>),
        sortMethod: (a, b, desc) =>
        {
          if (a > b)
            return 1;
          else
            return -1;
        }
      }
    ]

    this.debouncedSaveColumnWidths = window.debounce(this.saveColumnWidths, 500);

    this.state =
    {
      userList: [],
      sortColumn: undefined,
      selectedRows: [],
      selectedRow: undefined,
      columns: columns,
      spinnerIsSpinning: false,
      userAdminModalIsOpen: false
    }

    this.selectionHandler = this.selectionHandler.bind(this);
    this.fetchUserList = this.fetchUserList.bind(this);
    this.sortChanged = this.sortChanged.bind(this);
    this.openUserAdminModal = this.openUserAdminModal.bind(this);
    this.closeUserAdminModal = this.closeUserAdminModal.bind(this);
  }

  async fetchUserList()
  {
    this.setState({spinnerIsSpinning: true});
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getUserList');
    this.setState({spinnerIsSpinning: false});
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error loading user list');
    if (null !== result.jsonData) this.setState({ userList: result.jsonData });
  }

  openUserAdminModal(rowInfo)
  {
    this.setState(
    {
      userAdminModalIsOpen: true,
      selectedRow: rowInfo.row
    });
  }

  render()
  {
    const override = css`
      display: block;
      margin: 0 auto;
      border-color: red;
    `;
    
    if (this.props.tabId !== this.props.tabIndex) return false;
    
    return(
      <div>
      { this.state.userAdminModalIsOpen && (
        <UserAdminModal modalIsOpen={this.state.userAdminModalIsOpen} onClose={this.closeUserAdminModal} 
          rowInfo={this.state.selectedRow} 
        />
      )}
        <Col>
          <Row style={{paddingTop: "10px" }}>
            <ButtonToolbar>
              <ButtonGroup size="sm">
                <Button style={{backgroundColor: 'transparent'}} title="Refresh" onClick={this.fetchUserList}><img src="assets/images/refresh.png" alt="Refresh" /></Button>
              </ButtonGroup>
            </ButtonToolbar>
          </Row>
          <Row>
            <ReactTable data={this.state.userList} columns={this.state.columns} minRows={1} className="-striped -highlight" 
              onResizedChange={(resizedColumns, event) => this.debouncedSaveColumnWidths(resizedColumns, event)} 
              defaultSorted={this.state.sortColumn} onSortedChange={this.sortChanged}
              getTrProps={(state, rowInfo, column) => 
                { 
                  if (rowInfo === undefined) return { };                
                  let x = this.state.selectedRows.indexOf(rowInfo.index);
                  if (-1 === x) 
                    return {} 
                  else
                    return {style: {fontWeight: "bold", color: "#ffffff", backgroundColor: "#0275d8"}} // #0275d8 matches reactstrap, #00abc7 matches uploader theme
                }}
                getTdProps={(state, rowInfo, column, instance) => {
                  return {
                    onClick: (e, handleOriginal) => {this.selectionHandler(e, handleOriginal, rowInfo, column, instance)},
                    onDoubleClick: this.openUserAdminModal.bind(this, rowInfo),
                  }
                }}
            />
          </Row>
        </Col>
        <div style={{position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}>
          <RingLoader css={override} size={75} color={'#4A90E2'} loading={this.state.spinnerIsSpinning}/>          
        </div>
      </div>
    );
  }

  saveColumnWidths(resizedColumns)
  {
    this.context.appLocalStorage.saveColumnWidths(resizedColumns, this.columnWidths, this.columnKey);
  }

  selectionHandler(event, handleOriginal, rowInfo, column, instance)
  {
    if (typeof rowInfo === 'undefined' || this.disableSelectionHandler)
      return;

    let selectedRows = this.state.selectedRows;      
    let absoluteViewIndex = (rowInfo.page * rowInfo.pageSize) + rowInfo.viewIndex;

    if (event.shiftKey)
    {
      if (undefined !== this.currentViewIndex)
      {
        let max = Math.max(absoluteViewIndex, this.currentViewIndex);
        let min = Math.min(absoluteViewIndex, this.currentViewIndex);

        selectedRows = [];
        for (let x = min; x <= max; x++)
          selectedRows.push(instance.state.sortedData[x]._index);
      }
      else
        selectedRows.push(rowInfo.index);
    }
    else if (event.ctrlKey)
    {
      let x = this.state.selectedRows.indexOf(rowInfo.index);
      if (-1 === x)
      {
        selectedRows.push(rowInfo.index);
      }
      else
      {
        selectedRows.splice(x, 1);
      }
    }
    else
    {
      selectedRows = [];
      selectedRows.push(rowInfo.index);
    }

    this.currentViewIndex = absoluteViewIndex;

    this.setState({selectedRows: selectedRows});
    window.clearTextSelection();
  }

  sortChanged(sortColumn)
  {
    this.context.appLocalStorage.setItem(this.sortColumnLS, JSON.stringify(sortColumn));
  }
}

UserList.contextType = AppContext;

export default UserList